import {
  DATE_FULL_YEAR,
  DATE_FULL_YEAR_LESS_1,
  DATE_FULL_YEAR_LESS_2,
  DATE_FULL_YEAR_LESS_3,
  DATE_FULL_YEAR_LESS_4,
} from "./valueStaticConstants";

export const PaymentModalStates = {
  CHOOSE_PAYMENT_METHOD: 0,
  CONTADO_METHOD: 1,
  BCP: 2,
  BBVA: 3,
  CREDIT_METHOD: 4,
  INTERBANK: 5,
  SCOTIABANK: 6,
  BANKNATION: 7,
  COLLECTION_PAYMENT_METHOD: 8,
};

export const ImportFlowScreens = {
  DOCUMENT_MANAGEMENT: 0,
  ORDERS: 1,
  PAYMENT: 2,
  VCT: 3,
  CHATBOT: 4,
  CREATE_COMPLAINT: 5,
  COMPLAINT_STATUS: 6,
  USERS: 7,
  COMPANY_DATA: 8,
  USER_DATA: 9,
};

export const CreateComplaintTypes = {
  COMPLAINANT_ID: 0,
  COMPLAINT_INFORMATION: 1,
  COMPLAINT_REGISTRATION: 2,
};

export const DocumentManagementTypes = {
  SENASA_RESTRICTION: 0,
  ELECTRONIC_MANDATE: 1,
  THIRD_PARTY_AUTH: 2,
  CREDIT_AUTH: 3,
  AGENT_CARGO: 4,
};

export const AdminManagementTypes = {
  DOCUMENT_VALIDATION: 0,
  PAYMENT_VALIDATION: 1,
  TURN_CONFIRMATION: 2,
  APPOINTMENT_CONFIGURATION: 3,
  COMPLAINTS: 4,
  APPOINTMENT_TICKETS: 5,
};

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const GRAPHQL_METHODS = {
  QUERY: "QUERY",
  MUTATION: "MUTATION",
};

export const FILE_FORMATS = {
  PDF: [".pdf"],
  IMAGE: [".jpg", ".png"],
  ZIP: [".zip", ".rar"],
  EXCEL: [
    ".csv",
    { accept: "application/vnd.ms-excel", extension: ".xls" },
    {
      accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      extension: ".xlsx",
    },
  ],
};

export const FILTERS = {
  APPOINTMENT: {
    STATUS: [
      { value: "turn_pending_creation", label: "Turno pendiente de creación" },
      { value: "turn_created", label: "Turno creado" },
      { value: "waiting", label: "Esperando" },
      { value: "turn_not_created", label: "Turno no creado" },
      { value: "calling", label: "Llamando" },
      { value: "serving", label: "En dique" },
      { value: "served", label: "Atendido" },
      { value: "missed", label: "Turno perdido" },
      { value: "canceled", label: "Cancelado" },
      { value: "no_turn", label: "Sin turno" },
    ],
  },
  VALIDATION: {
    STATUS: [
      { value: "PENDING", label: "Pendiente" },
      { value: "APPROVED", label: "Aprobado" },
      { value: "REJECTED", label: "Rechazado" },
      { value: "REVIEWING", label: "En revisión" },
    ],
    PAYMENT_STATUS: [
      { value: "PENDING_VALIDATION", label: "Pendiente de validación" },
      { value: "PAID", label: "Pagado" },
      { value: "REJECTED", label: "Rechazado" },
      { value: "EXPIRED", label: "Pago vencido" },
    ],
    REGIMES: [{ id: "10", name: "Imp. Definitiva" }],
    YEARS: [
      DATE_FULL_YEAR,
      DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_1,
      DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_2,
      DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_3,
      DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_4,
    ],
  },
  VALIDATION_THIRD: {
    STATUS: [
      { value: "not_required", label: "No requerido" },
      { value: "approved", label: "Aprobado" },
      { value: "rejected", label: "Rechazado" },
      { value: "reviewing", label: "En revisión" },
    ],
  },
  PAYMENT: {
    TYPE: {
      QUOTED: 0,
      VALIDATION: 1,
      PAID: 2,
    },
    CONDITION: [
      { value: "UPFRONT", label: "Recaudo" },
      { value: "UPFRONT_MANUAL", label: "Contado" },
      { value: "CREDIT", label: "Crédito" },
    ],
    // TODO: CHANGE IN FUTURE
    STATUS: [
      { value: "PENDING_PAYMENT", label: "Pendiente de pago" },
      { value: "PENDING_VALIDATION", label: "Pendiente de validación" },
      { value: "REJECTED", label: "Rechazado" },
      { value: "EXPIRED", label: "Pago vencido" },
    ],
    RETIREMENT: [
      { value: "pending", label: "Pendiente" },
      { value: "expired", label: "Vencido" },
    ],
  },
};

export const DAM_STATUS = {
  SENASA: {
    id: 0,
    typeLabel: "RESTRICCIÓN SENASA",
    message:
      "La partida arancelaria es parte de la lista de mercadería restringida.",
  },
  ELECTRONIC_MANDATE: {
    id: 1,
    typeLabel: "MANDATO ELECTRÓNICO",
    message: "No cuenta con mandato electrónico.",
  },
  LEVANTE: {
    id: 2,
    typeLabel: "RESTRICCIÓN DE LEVANTE",
    message: "Tiene bloqueo de salida del Almacén Aduanero.",
  },
  ACE_BLOCK: {
    id: 3,
    typeLabel: "BLOQUEO ACE",
    message:
      "Los documentos de transporte declarados en esta DAM cuentan con bloqueo ACE o medidas preventivas pendientes.",
  },
};

export const REQUEST_STATES = {
  PRE_REQUEST: 0,
  REQUEST_IN_PROGRESS: 1,
  REQUEST_FULFILLED: 2,
  ERROR: 3,
};

/* TODO: clean those that aren't a beta feature anymore */
export const BETA_FEATURES = {
  CONTADO_PAYMENT: true,
  PASSWORD_RECOVERY: true,
  COMPLAINTS_SCREEN: true,
  CHATBOT_SCREEN: false,
  USERS_SCREEN: true,
};

export const ACE_BLOCK_MESSAGES = {
  "00": ["No existen Acciones de control."],
  "01": [
    "Tiene Acciones de control, puede retirar parcial.",
    "DAM tiene Acta de Incautación o de Inmovilización parcial, pendiente",
  ],
  "02": [
    "Tiene Acción de control, no puede retirar.",
    "DAM tiene ACE pendiente.",
    "Tiene Acta de Incautación o de Inmovilización por el total de la DAM en estado pendiente",
    "Tiene bloqueo de salida del Almacén Aduanero.",
    "Tiene documento de transporte declarados en DAM cuentan con ACE o medidas preventivas pendientes",
  ],
  "03": ["Tiene Acción de control concluida, puede retirar."],
  "04": ["Tiene selección a SINI pendiente"],
};

export const AUTHENTICATION_STEPS = {
  LOGIN: 0,
  FORGOT_PWD_EMAIL: 1,
  FORGOT_PWD_CODE: 2,
  FORGOT_PWD_NEW: 3,
  SET_PWD: 4,
};

export const CURRENCIES = [
  { value: "pen", label: "Soles (S/)" },
  { value: "usd", label: "Dólares ($)" },
];

export function getCurrencyObject(useUsd) {
  const index = useUsd ? 1 : 0;
  return CURRENCIES[index];
}

export const BANKS = {
  bbva: {
    code: "bbva",
    name: "BBVA",
    soles: {
      accountNumber: "0011-0910-71-0100010639",
      accountCCICode: "011-910-000100010639-71",
    },
    dollars: {
      accountNumber: "0011-0350-67-0100002764",
      accountCCICode: "011-350-000100002764-67",
    },
  },
  bcp: {
    code: "bcp",
    name: "Banco de Crédito del Perú",
    soles: {
      accountNumber: "192-0791363-0-64",
      accountCCICode: "002-192-000791363064-31",
    },
    dollars: {
      accountNumber: "192-0841819-1-30",
      accountCCICode: "002-192-000841819130-33",
    },
  },

  interbank: {
    code: "interbank",
    name: "Institución financiera Interbank",
    soles: {
      accountNumber: "200-3001040853",
      accountCCICode: "003-200-003001040853-39",
    },
    dollars: {
      accountNumber: "200-3000614081",
      accountCCICode: "003-200-00300614081-35",
    },
  },
  scotiabank: {
    code: "scotiabank",
    name: "Banco Scotiabank",
    soles: {
      accountNumber: "000-6753558",
      accountCCICode: "009-170000006753558-23",
    },
    dollars: {
      accountNumber: "000-3369262",
      accountCCICode: "009-170000003369262-25",
    },
  },
  nacion: {
    code: "nacion",
    name: "Banco de la Nación",
    soles: {
      accountNumber: "00-000-471550",
      accountCCICode: "00-000-471550",
    },
    dollars: {
      accountNumber: "00-000-471550",
      accountCCICode: "00-000-471550",
    },
  },
};

export const DISPATCH_TYPES = {
  "00": {
    category: "warning",
    label: "Retiro Excepcional",
  },
  "01": {
    category: "problem",
    label: "Retiro Urgente",
  },
  10: {
    category: "ok",
    label: "Retiro Anticipado",
  },
};

export const NOTIFICATION_POOL_INTERVAL = 30000;

export const NOTIFICATION_SECTION_POOL_INTERVAL = 20000;

export const DATE_SELECT = [
  { label: DATE_FULL_YEAR.toString(), value: DATE_FULL_YEAR.toString() },
  {
    label: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_1).toString(),
    value: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_1).toString(),
  },
  {
    label: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_2).toString(),
    value: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_2).toString(),
  },
  {
    label: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_3).toString(),
    value: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_3).toString(),
  },
  {
    label: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_4).toString(),
    value: (DATE_FULL_YEAR - DATE_FULL_YEAR_LESS_4).toString(),
  },
];
